import { http, handleHttpRequest, type HttpResponse } from 'interfaces'
import type { MemberInformation } from '../person/us/edit/memberInfoService'
import { type CommitteeMember } from 'pages'

export async function retireCommitteeMember (comId: number, memberId: number): Promise<HttpResponse<void>> {
  return await http.delete(`/api/v1/us/committee/${comId}/member/${memberId}/`, {
  }).then(value => value.data)
}

export async function addCommitteeMember (comId: number, member: MemberInformation, selectedLegRoleId: number): Promise<HttpResponse<CommitteeMember>> {
  return await handleHttpRequest(http.post(`/api/v1/us/committee/${comId}/member/`, { member, selectedLegRoleId }))
}
